import { Controller } from '@hotwired/stimulus';

// Controller for a rendered resource/article body.
//
// The CMS renders embedded calculators/coaches as self-contained <iframe>s
// (src = .../coach/resizable/<id>?embedded=true&subdomain=banzai). Those iframes
// post their content height to the parent via `postMessage`; without a listener
// they stay pinned at their min-height (~200px) and look empty/cut off.
//
// Mirror content-web's own bz-article.js `setupIframeResizing`: on connect,
// listen for each coach iframe's resize message and set its height; on
// disconnect (Turbo frame teardown), remove the listeners so navigating between
// articles doesn't leak them.
export default class extends Controller {
  connect() {
    this.iframeHandlers = [];
    this.element.querySelectorAll('iframe[data-coach-id]').forEach((iframe) => {
      const handler = (event) => {
        if (event.source !== iframe.contentWindow) return;
        const data = event.data;
        if (data && data.type === 'resize' && typeof data.height === 'number') {
          iframe.style.height = `${data.height}px`;
        }
      };
      window.addEventListener('message', handler);
      this.iframeHandlers.push(handler);
    });
  }

  disconnect() {
    (this.iframeHandlers || []).forEach((handler) => {
      window.removeEventListener('message', handler);
    });
    this.iframeHandlers = [];
  }
}
